import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=5763ea78"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"
import style0 from "./Body.vue?vue&type=style&index=0&id=5763ea78&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports